import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

import { FormsGlobals } from '../../../models/forms/forms.enum';
import { FormParagraphDataModel } from '../../../models/forms/data/form-paragraph-data.model';
import { FormItemDataModel } from '../../../models/forms/data/form-item-data.model';
import { FormItemRowModel } from '../../../models/forms/data/form-item-row.model';
import { FormParagraphConfigurationModel } from '../../../models/forms/form-paragraph-configuration.model';
import { PatientCaseWorkItemFormDataModel } from '../../../models/forms/data/patient-case-work-item-form-data.model';

@Component({
  selector: 'app-forms-paragraph',
  templateUrl: './forms-paragraph.component.html',
  styleUrls: ['./forms-paragraph.component.css']
})
export class FormsParagraphComponent implements OnInit {
  @Output() saveDataNoteEvent = new EventEmitter<any>();

  @Input() dataForm: PatientCaseWorkItemFormDataModel;
  @Input() containerDimensions: any;
  @Input() paragraphIndex: number;
  @Input() dataFormParagraph: FormParagraphDataModel;
  @Input() saveEmitter: EventEmitter<any>;
  @Input() dataFormID: string;
  @Input() actionsEnabled: boolean;
  @Input() colorGuides: boolean = false;
  @Input() hasPageBreak: boolean = false;
  @Input() CaseWorkItemFormsId: string;

  get relatedRepeatingParagraph() {
    return this.repeatingParagraph;
  }
  @Input()
  set relatedRepeatingParagraph(val) {
    this.repeatingParagraph = val;
  }

  repeatingParagraph: FormParagraphConfigurationModel;

  isGridLayout = true;

  minWidth: number = 0;
  forceHorizontalMode: boolean = false;
  itemOrganizerArray: any[];
  gridItemOrganizer: FormItemDataModel[];
  maxCol: number = 0;
  collapsed: boolean = false;
  summary: string = '';

  itemRows: Array<FormItemRowModel>;
  isFormLocked: boolean = false;
  isPatientUser: boolean = false;

  constructor(
    public formsGlobals: FormsGlobals
  ) { }

  ngOnInit() {
    const isPatientRole = localStorage.getItem('isPatientRole');
    if (isPatientRole && isPatientRole === 'true') {
      this.isPatientUser = true;
    }

    this.isFormLocked = this.dataForm.enumFormCompletionStatusID == this.formsGlobals.STATUS_COMPLETED || this.dataForm.enumFormCompletionStatusID == this.formsGlobals.STATUS_COMPLETEDANDSIGNED;
    this.itemRows = new Array<FormItemRowModel>();

    //AV - Sorted by row then column
    const paragraphRows = this.dataFormParagraph.dataFormItems.map(item => item.cfgDFormItem?.ParagraphRow  != null ? item.cfgDFormItem?.ParagraphRow : 99999);
    //console.log('FormsParagraphComponent paragraphRows', paragraphRows);
    let currentParagraphRow = Math.min(...paragraphRows);
    const totalParagraphRows = Math.max(...paragraphRows);

    let itemsInParahraphRow = this.dataFormParagraph.dataFormItems
      .filter(item => item.cfgDFormItem?.ParagraphRow == currentParagraphRow)
      .sort((a, b) => { return a.cfgDFormItem.ParagraphColumn - b.cfgDFormItem.ParagraphColumn; });

     //if (this.dataFormParagraph.ParagraphOrder ===0) {
    //  console.log("FormsParagraphComponent currentParagraphRow", currentParagraphRow);
    //  console.log('FormsParagraphComponent ParagraphOrder', this.dataFormParagraph.ParagraphOrder);
    //   console.log('dataFormParagraph.dataFormItems', this.dataFormParagraph.dataFormItems);
    //  console.log('FormsParagraphComponent itemsInParahraphRow', itemsInParahraphRow);
    // }

    while (itemsInParahraphRow.length > 0) {
      const itemRow = new FormItemRowModel();
      itemRow.index = currentParagraphRow;
      itemRow.items = itemsInParahraphRow;
      this.itemRows.push(itemRow);

      currentParagraphRow++;
      while (currentParagraphRow <= totalParagraphRows && this.dataFormParagraph.dataFormItems.findIndex(item => item.cfgDFormItem?.ParagraphRow == currentParagraphRow) < 0) {
        currentParagraphRow++;
      }
      console.log('FormsParagraphComponent currentParagraphRow:', currentParagraphRow);
      itemsInParahraphRow = this.dataFormParagraph.dataFormItems
        .filter(item => item.cfgDFormItem?.ParagraphRow == currentParagraphRow)
        .sort((a, b) => { return a.cfgDFormItem.ParagraphColumn - b.cfgDFormItem.ParagraphColumn; });
    }

    if (this.hasPageBreak) {
      this.minWidth = this.minWidth - 34;
    }

    setTimeout(_ => {
      this.buildResultSummary();
    }, 2000);

      this.setActionButtonsVisibility();

  }

  setActionButtonsVisibility() {
    const collection = document.querySelectorAll<HTMLElement>(".form-item-action-button");
    for (let i = 0; i < collection.length; i++) {
      collection[i].style.display = "none";
    }
    if (collection.length > 0) 
      collection[collection.length-1].style.display = "block";

    const deleteActions = document.querySelectorAll<HTMLElement>(".form-item-action-button-delete");
    if (deleteActions.length === 1) {
      deleteActions[0].style.display = "none";
    }
  }

  buildResultSummary() {
    let summary = '';
    this.dataFormParagraph.dataFormItems.forEach(item => {
      let itemSentence = (item.cfgDFormItem !== null && item.cfgDFormItem.Label !== null) ? `${item.cfgDFormItem.Label} ` : '';
      if (item.dataFormResults && item.dataFormResults.length) {
        const nonDeletedResults = item.dataFormResults.filter(result => !result.xauditDeleted);
        if (item.cfgDFormItem && item.cfgDFormItem.ValidValue && item.cfgDFormItem.ValidValue.enumValidValueItems) {
          const validValueArr = [];
          nonDeletedResults.forEach(result => {
            item.cfgDFormItem.ValidValue.enumValidValueItems.forEach(validValueItem => {
              if (validValueItem.ValidValueItemId === result.Result && result.Result != null) {
                validValueArr.push(validValueItem.ItemDisplayValue);
              }
            });
          });
          itemSentence += validValueArr.join(' ');
        } else {
          itemSentence += nonDeletedResults.map(result => (result.Result == null || result.Result == 'null') ? '' : result.Result).join(' ');
        }
        summary += itemSentence + ' ';
      }
    });
    this.summary = summary;
  }


  getRandomColor() {
    const colors: string[] = [
      '#FF5733', '#FF3333', '#FFD133', '#A6F51C', '#36F51C', '#1CF5B3', '#1CF5EE', '#1CA9F5', '#1C5EF5', '#641CF5', '#A91CF5', '#F51CF5', '#F51CAD', '#F51C71', '#ED4747'
    ];
    const color = colors[Math.floor(Math.random() * colors.length)];
    return color;
  }



  // you need to find the total width for the cols
  // you need to find with width of the container
  // you need to adjust the amount of columns depending on the width
  // this wont work. for mobile you will need to re adjust every column for the paragraphs...

  detectMobile() {
    // what width do we consider mobile?
    //
  }

  // Passing event back to form level so all items can be looped through
  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  onSaveDataNote(event) {
    this.saveDataNoteEvent.emit(event);
  }
}
